
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiMenuIec as ObiMenuIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-menu-iec.js';
 
 
 

 
 export const ObiMenuIec = createComponent({
   react: React,
   tagName: 'obi-menu-iec',
   elementClass: ObiMenuIecElement,
   events: {
     
   }
  });
 
 